"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _isEnter = _interopRequireDefault(require("../../helpers/isEnter"));

var EventHandler = /*#__PURE__*/function () {
  function EventHandler(setStateValues) {
    (0, _classCallCheck2["default"])(this, EventHandler);
    this.setStateValues = setStateValues;
    this.displayName = 'SelectInputEventHandler';
  }

  (0, _createClass2["default"])(EventHandler, [{
    key: "handleUpdate",
    value: function handleUpdate(event) {
      this.setStateValues({
        storedValue: event.target.value,
        dirty: true,
        complete: true
      });
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      this.handleUpdate(event);
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      if ((0, _isEnter["default"])(event)) {
        this.handleUpdate(event);
      }
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(value) {
      this.setStateValues({
        storedValue: value,
        dirty: value.length > 0,
        complete: true,
        isFocused: false
      });
    }
  }]);
  return EventHandler;
}();

var _default = EventHandler;
exports["default"] = _default;